export interface SchoolPluginConfigInterface {
  /**
   * [通用]
   *  - oauth 客户端 ID
   *  - 前端传入/后台自动生成
   *  - 唯一标识
   */
  clientId?: string
  /**
   * [通用]
   *  - oauth 客户端 密码
   *  - 前端传入(不加密保存)
   */
  clientSecret?: string
  /**
   * [seiue]
   *  - 关联学校ID
   */
  schoolId?: number
  /**
   * [seiue]
   *  - 客户端登录成功后的跳转客户端地址
   *  - eg: http://127.0.0.1:7799/sso/oauth/callback
   */
  loginUri?: string
  /**
   * [seiue]
   *  - 客户端登录成功后的回调客户端地址
   *  - eg: http://127.0.0.1:7799/sso/oauth/callback
   */
  redirectUri?: string
  /**
   * [通用]
   *  - oauth 授权类型
   */
  grantTypes?: string | null
  /**
   * [通用]
   *  - oauth 授权范围
   */
  scope?: string | null
  /**
   * [nocobase]
   *  - x-authenticator nocobase 的 oidc 插件的唯一标识
   */
  xAuthenticator?: string | null
  /**
   * [nocobase]
   *  - 跳转后的默认路径 示例: /admin
   */
  redirectUriPath?: string | null
}

export class SchoolPluginConfig implements SchoolPluginConfigInterface {
  /**
   * [通用]
   *  - oauth 客户端 ID
   *  - 前端传入/后台自动生成
   *  - 唯一标识
   */
  clientId?: string
  /**
   * [通用]
   *  - oauth 客户端 密码
   *  - 前端传入(不加密保存)
   */
  clientSecret?: string
  /**
   * [seiue]
   *  - 关联学校ID
   */
  schoolId?: number
  /**
   * [seiue]
   *  - 客户端登录成功后的跳转客户端地址
   *  - eg: http://127.0.0.1:7799/sso/oauth/callback
   */
  loginUri?: string
  /**
   * [seiue]
   *  - 客户端登录成功后的回调客户端地址
   *  - eg: http://127.0.0.1:7799/sso/oauth/callback
   */
  redirectUri?: string
  /**
   * [通用]
   *  - oauth 授权类型
   */
  grantTypes?: string | null
  /**
   * [通用]
   *  - oauth 授权范围
   */
  scope?: string | null
  /**
   * [nocobase]
   *  - x-authenticator nocobase 的 oidc 插件的唯一标识
   */
  xAuthenticator?: string | null
  /**
   * [nocobase]
   *  - 跳转后的默认路径 示例: /admin
   */
  redirectUriPath?: string | null

  constructor(props: SchoolPluginConfigInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      clientId: _clientId,
      clientSecret: _clientSecret,
      schoolId: _schoolId,
      loginUri: _loginUri,
      redirectUri: _redirectUri,
      grantTypes: _grantTypes,
      scope: _scope,
      xAuthenticator: _xAuthenticator,
      redirectUriPath: _redirectUriPath,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.clientId = _clientId
    this.clientSecret = _clientSecret
    this.schoolId = _schoolId
    this.loginUri = _loginUri
    this.redirectUri = _redirectUri
    this.grantTypes = _grantTypes
    this.scope = _scope
    this.xAuthenticator = _xAuthenticator
    this.redirectUriPath = _redirectUriPath
  }
}
